<!--选择excle文件并上传页面-->
<template>
  <div>
    <el-row>
      <el-col :span="24">
        <Header></Header>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="4">
        <MenuList></MenuList>
      </el-col>
      <el-col :span="20">
        <div>
          <el-divider>合并成绩单</el-divider>
        </div>
        <div style="padding-left: 20px;font-size: 16px;font-weight: bold;">表头(姓名、学号科目等名称)必须在同一行上才能正确导入。<span
            style="color: red;">如果不显示数据或出现白页等情况，请将文件另存为“Microsoft
            excel 97-2003文件(*.xls)”文件后再上传。</span></div>

        <div style="padding: 10px;">
          <div style="padding: 10px;">
            <el-form ref="editForm" :model="editForm" size="mini">
              <div>
                <el-form-item>
                  <el-upload class="upload-demo" :http-request="uploadFile" action :on-preview="handlePreview"
                    :on-remove="handleRemove" :on-change="fileChange" :before-remove="beforeRemove" accept=".xls,.xlsx"
                    multiple :limit="1" :on-exceed="handleExceed" :file-list="fileList">
                    <div class="uploadFileStyle">
                      <el-tooltip class="item" effect="dark"
                        content="如果文件大小超过5M,可能传不上去。减小文件大小的方法是：新建一个excel文件,把旧文件中数据复制粘贴到新文件中保存,新文件会变小。可联系客服免费协助解决."
                        placement="bottom">
                        <el-button type="primary" plain>+点击上传Excel文件(Office 2007以上版本文件)</el-button>
                      </el-tooltip>

                      <div slot="tip" class="el-upload__tip" style="font-size: 18px;"></div>
                    </div>
                  </el-upload>
                  <div style="margin-top: 10px;" v-show="fileList.length>0">
                    <el-button type="primary" plain @click="emptyFileList">-删除文件</el-button>
                  </div>
                </el-form-item>
              </div>

              <el-form-item size="large">
                <el-tooltip class="item" effect="dark"
                  content="请不要使用IE浏览器.其他浏览器如果点击无反应,把浏览器切换成'高速模式'后重新登录再试试.切换方法见下方帮助." placement="bottom">
                  <el-button size="small" type="primary" @click="uploadExcelFile">下一步</el-button>
                </el-tooltip>
              </el-form-item>

              <div>
                <el-button @click="howToSwitch" type="text" size="medium">
                  如何将浏览器切换成"高速模式"或"快速模式"
                </el-button>
              </div>

<!--              <div>
                <el-link type="danger" href="http://www.sales1.top/score/help/score_import.mp4" target="_blank">点我观看操作视频
                </el-link>
              </div> -->

<!--              <div style="margin-top: 10px;">
                <el-link type="danger"
                  href="javascript:window.open('http://wpa.qq.com/msgrd?v=3&uin=34424698&site=qq&menu=yes', '_brank')"
                  target="_blank">点我寻求客服QQ远程支持</el-link>
              </div> -->

              <!-- <div style="color:red;padding-top: 20px;">点下一步后长时间等待没有反应怎么办？<br>长时间没反应通常是excel文件过大造成的，请新建一个excel文件，把当前文件内容复制粘贴到新文件中即可，新的文件会变的小很多，把新文件上传即可。</div> -->
            </el-form>
          </div>

        </div>
      </el-col>
    </el-row>

    <el-dialog width="80%" :close-on-click-modal="false" title="如何切换浏览器的模式" :visible.sync="browserSwitchDialogVisible">
      <div class="colStyle">

        如下图所示找到红色框的部分，点击一下，切换到闪电图标上或者是"极速模式"或"高速模式"
        <br /><br />
        <img src="../assets/switch_browser.png" width="100%" />
        <br /><br />
        正确的应该是如下图所示：
        <br /><br />
        <img src="../assets/good_browser.png" width="100%" />
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="browserSwitchDialogVisible=false">我知道了</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import MenuList from './menu.vue'
  import Header from './head.vue'

  export default {
    components: {
      MenuList,
      Header
    },
    data() {
      return {
        exam_id: '',
        browserSwitchDialogVisible: false,
        fileList: [],
        courses: [],
        file: '',
        editForm: {
          id: '',
          exam: '',
          course: '',
          grade: '',
          paper_score: ''
        }
      }
    },
    created() {
      // console.log('调用exam_list created')
      this.exam_id = this.$route.params.exam_id

      this.loadCourses()
    },
    methods: {
      handleRemove(file, fileList) {
        this.fileList = []
      },
      handlePreview(file) {},
      uploadFile(file) {
        // this.data.append('file', file.file)
      },
      handleExceed(files, fileList) {
        this.$message.warning(`请先删除原来上传的文件后再上传!`)
        return true
      },
      beforeRemove(file, fileList) {
        return this.$confirm(`确定移除 ${file.name}？`)
      },
      uploadExcelFile() {
      if (this.fileList.length === 0) {
          this.$message.error('请选择excel文件！')
          return
        }

        let that = this

        let data = new FormData()
        data.set('exam', this.editForm.exam)
        data.set('grade', this.editForm.grade)

        let tmpExcelFile = this.fileList[0].raw

        // console.log(tmpExcelFile)

        data.append('file', tmpExcelFile)

        // 开启loading
        const load = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })

        var requestUrl = '/score/web/_team_upload_any_excel.jsp'
        this.axios.post(requestUrl, data, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }).then(res => {
          // console.log('数据导入完成！！')

          if (res.data.result !== '-1') {
            var jsList = encodeURIComponent(JSON.stringify(res.data))
            // console.log(res.data)

            that.$router.push({
              name: 'team_exam_excel_preview_ex',
              params: {
                jsList: jsList,
                exam_id: that.exam_id
              }
            })
          } else {
            // 导入错误
            console.log('数据导入错误')
            this.$alert('文件格式无法识别，请用WPS或者Office软件另存为"Microsoft excel 97-2003(.xls)文件"后再试。如果还不行，请联系客服解决。')
          }

          load.close()
        }).catch(err => {
          console.log('数据导入异常！！')
          console.log(err)
          load.close()
          that.$router.push('/team_exam_list_anyfile_ex')
        })
      },

      fileChange(file, fileList) {
        this.fileList = fileList
        console.log(fileList)
        return true
      },
      loadCourses() {
        let that = this
        var requestUrl = '/score/web/_get_courses.jsp'

        this.axios.get(requestUrl, {
            params: {

            }
          }).then(function(response) {
            that.courses = response.data
          })
          .catch(function(error) {
            console.log(error)
          })
      },
      back() {
        this.$router.push('/exam_list')
      },
      emptyFileList() {
        this.fileList = []
      },
      howToSwitch() {
        this.browserSwitchDialogVisible = true
      }

    }
  }
</script>

<style>
  .actionStyle {
    display: flex;
    flex-direction: column;

  }

  .uploadFileStyle {
    display: flex;
    align-items: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/team_exam_import_anyfile_ex.vue